import React from 'react';
import PropTypes from 'prop-types';
import ProjectStatusLabel from '../ProjectStatusLabel';

const renderAction = (proposal, status, acceptingProposals, projectLink) => {
  if (proposal) {
    if (status === 'edits_requested') {
      return <a href={`/proposals/${proposal.resource_id}`} className="btn btn-sm btn-primary mr-5">Review Feedback</a>;
    } if (status === 'drafting') {
      return <a href={`/proposals/${proposal.resource_id}`} className="btn btn-sm btn-primary mr-5">Review & Submit Proposal</a>;
    } if (status === 'submitted' || status === 'awarded' || status === 'rejected') {
      return <a href={`/proposals/${proposal.resource_id}`} className="btn btn-sm btn-default mr-5">View Proposal</a>;
    }
  } else {
    if (acceptingProposals) {
      if (status === 'rejected') {
        return <a href={projectLink} className="btn btn-sm btn-default mr-5">View Opportunity</a>;
      }
      return <a href={projectLink} className="btn btn-sm btn-primary mr-5">View Opportunity</a>;
    }

    return <div className="text-danger mb-0">This project is no longer available</div>;
  }

  return null;
};

function ConsultantProjectIndexRow({
  name,
  projectLink,
  proposal,
  status,
  aoe,
  acceptingProposals,
  hours,
  location,
}) {
  return (
    <div className="row vertical-align">
      <div className="col-xs-12 col-sm-6 col-md-4">
        <h4 className="mt-0 mb-0">
          <a href={projectLink} className="project-show">{name}</a>
        </h4>
        <h4 className="mt-0 mb-0">
          <small>{aoe}</small>
        </h4>
      </div>

      <div className="col-xs-12 col-sm-6 col-md-3">
        <h4 className="mt-0 mb-0">
          <small className="label-text">Weekly Committment: </small>
          <small>
            {' '}
            {hours}
          </small>
        </h4>
        <h4 className="mt-0 mb-0">
          <small className="label-text">Position Type: </small>
          <small>
            {' '}
            {location}
          </small>
        </h4>
      </div>

      <div className="col-xs-12 col-sm-6 col-md-2 text-center">
        <ProjectStatusLabel status={status} />
      </div>

      <div className="col-xs-12 col-sm-6 col-md-3">
        <div className="btn-group pull-right">
          {renderAction(proposal, status, acceptingProposals, projectLink)}
        </div>
      </div>
    </div>
  );
}

ConsultantProjectIndexRow.propTypes = {
  name: PropTypes.string.isRequired,
  proposal: PropTypes.shape({}),
  status: PropTypes.string.isRequired,
  projectLink: PropTypes.string.isRequired,
  acceptingProposals: PropTypes.bool,
  aoe: PropTypes.string,
  hours: PropTypes.string,
  location: PropTypes.string,
};

ConsultantProjectIndexRow.defaultProps = {
  acceptingProposals: true,
  aoe: null,
  hours: null,
  location: null,
  proposal: null,
};

export default ConsultantProjectIndexRow;
